var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11C9 8.85223 7.20914 7.11111 5 7.11111C2.79086 7.11111 1 8.85223 1 11M5 5.44444C3.73763 5.44444 2.71429 4.44952 2.71429 3.22222C2.71429 1.99492 3.73763 1 5 1C6.26237 1 7.28571 1.99492 7.28571 3.22222C7.28571 4.44952 6.26237 5.44444 5 5.44444Z",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagements);
export default __webpack_public_path__ + "static/media/engagements.25e5948161b83e86f30404ccb06fe825.svg";
export { ForwardRef as ReactComponent };